import styled from 'styled-components';

const FieldGroupContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
`;

export default FieldGroupContainer;
